/**
 * Updates a cart/favorite/otasuke item with the latest master sell data.
 * Preserves user-specific state like item.count, item.id, etc.
 * 
 * @param {Object} item - The item object stored in cart/favorite/otasuke
 * @param {Object} itemSellData - The latest document data from items_sell or items_stock
 * @param {boolean} urigawa - Whether current view is seller side (if urigawa is true, price might not be overwritten in certain views)
 * @returns {boolean} True if any field was changed, false otherwise.
 */
export const updateItemFromSellData = (item, itemSellData, urigawa = false) => {
  if (!item || !itemSellData) return false;

  let changed = false;

  // 1. Price
  if (!urigawa && itemSellData['price'] && Array.isArray(itemSellData['price']) && itemSellData['price'][0] && itemSellData['price'][0]['price'] !== undefined) {
    let newPrice = itemSellData['price'][0]['price'];
    if (item.price === undefined || Number(item.price) !== Number(newPrice) || item.price !== newPrice) {
      item.price = newPrice;
      changed = true;
    }
  }

  // 2. Tax rate (消費税率)
  if (itemSellData['消費税率'] !== undefined) {
    let newTax = itemSellData['消費税率'];
    if (item.tax === undefined || Number(item.tax) !== Number(newTax) || item.tax !== newTax) {
      item.tax = newTax;
      changed = true;
    }
  }

  // 3. Master Item Details
  if (itemSellData['P4CLOUD商品名'] && item.name !== itemSellData['P4CLOUD商品名']) {
    item.name = itemSellData['P4CLOUD商品名'];
    changed = true;
  }
  if (itemSellData['正式メーカー名'] && item.maker !== itemSellData['正式メーカー名']) {
    item.maker = itemSellData['正式メーカー名'];
    changed = true;
  }
  if (itemSellData['販売企業商品コード'] && item.code !== itemSellData['販売企業商品コード']) {
    item.code = itemSellData['販売企業商品コード'];
    changed = true;
  }
  if (itemSellData['仕入先事業所コード'] && item.sellercode !== itemSellData['仕入先事業所コード']) {
    item.sellercode = itemSellData['仕入先事業所コード'];
    changed = true;
  }
  if (itemSellData['仕入先事業所名'] && item.sellername !== itemSellData['仕入先事業所名']) {
    item.sellername = itemSellData['仕入先事業所名'];
    changed = true;
  }
  if (itemSellData['仕入先EDIコード商品コード'] && item.makeredicode !== itemSellData['仕入先EDIコード商品コード']) {
    item.makeredicode = itemSellData['仕入先EDIコード商品コード'];
    changed = true;
  }
  if (itemSellData['仕入先発注コード'] && item.makerordercode !== itemSellData['仕入先発注コード']) {
    item.makerordercode = itemSellData['仕入先発注コード'];
    changed = true;
  }
  if (itemSellData['archive'] !== undefined && item.archive !== itemSellData['archive']) {
    item.archive = itemSellData['archive'];
    changed = true;
  }

  return changed;
};
